exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumb.custom[data-v-088ab7da]{background:#f8f8f8;padding:0;margin-bottom:15px;border-radius:0}.breadcrumb.custom ul.breadcrumb[data-v-088ab7da]{padding:10px 15px;list-style:none;background-color:transparent;margin-bottom:0}.breadcrumb.custom ul.breadcrumb li[data-v-088ab7da]{display:inline}.breadcrumb.custom ul.breadcrumb li a[data-v-088ab7da]{color:#b4b4b4}.breadcrumb.custom ul.breadcrumb li+li[data-v-088ab7da]:before{padding:5px;color:#b4b4b4;content:\"/\\A0\"}@media (max-width:991px){.breadcrumb.custom ul.breadcrumb[data-v-088ab7da]{margin:0;padding:10px 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-088ab7da","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Front/Breadcrumb/index.vue
// module id = 1014
// module chunks = 0